import script from "./TableView.vue?vue&type=script&setup=true&lang=js"
export * from "./TableView.vue?vue&type=script&setup=true&lang=js"

import "./TableView.vue?vue&type=style&index=0&id=00783155&scoped=true&lang=css"
import "./TableView.vue?vue&type=style&index=1&id=00783155&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00783155"]])

export default __exports__